import { styled } from "@mui/material/styles";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Fragment } from "preact";
import { clearLocalStorage, getLocalStorage, clearCookies } from "../../utils";
import { useEffect, useState } from "preact/hooks";
import {
  AdUnits,
  Campaign,
  Celebration,
  CheckBox,
  Close,
  Fastfood,
  Home,
  Leaderboard,
  LocalOffer,
  Logout,
  Menu,
  SupervisedUserCircle,
  Tune,
  Verified,
  Wallet,
} from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import Logo from "../../assets/logo.png";
import { route } from "preact-router";
import { logoutApi } from "../../api/controller/accounts";
import useApi from "../../hooks/useApi";
const ContentWrapper = styled("div")`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 6px;
  .leftText {
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
  }
  .rightText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
  }

  .notificationsIcon {
    // margin-left: 20px;
  }
  .menuIcon {
    color: white;
    display: none;
    padding-right: 6px;
  }
  .nav-menu {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    width: 100%;
    background-color: rgba(28, 28, 30, 0.95);
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    height: 650px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 9999;
  }
  .userRoutes {
    text-align: center;
    height: auto;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding-left: 10px;
  }
  .userStateRoutes {
    width: 100%;
  }

  .navbarContainer {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
    padding-left: 16px;
  }

  .navbarIcon {
    height: 21px;
    width: 21px;
    color: #c4c4c4;
  }
  .navbarRoute {
    color: #c4c4c4;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-left: 10px;
  }
  .activeNavbarIcon {
    height: 21px;
    width: 21px;
    color: #fff;
  }
  .activeNavbarRoute {
    margin-left: 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  .textMessage {
    color: #f7f7f7;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    padding-top: 10px;
    padding-left: 16px;
    display: flex;
  }
  .notificationsIcon.mobile {
    display: none;
  }
  .leftTextHere {
    display: none;
  }

  @media only screen and (max-width: 724px) {
    .nav-menu {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      width: 100%;
      background-color: rgba(28, 28, 30, 0.95);
      color: white;
      position: fixed;
      top: 0;
      left: 0;
      height: 700px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      z-index: 99999;
    }
    .userRoutes {
      text-align: center;
      height: auto;
      max-height: calc(100vh - 150px);
      overflow-y: auto;
      padding-left: 10px;
    }
    .leftTextHere {
      color: #f7f7f7;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
    }
    .leftText {
      display: none;
    }

    .pendingRequestCount {
      display: none;
    }
    .menuIcon {
      display: block;
      padding-right: 10px;
    }
    .notificationsIcon {
      display: none;
    }
    .notificationsIcon.mobile {
      display: block;
    }
  }

  .hostMessage {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const ExploreButton = styled("button")`
  position: relative;
  background: #1a1a1a;
  color: white;
  border: 1px solid transparent;
  border-radius: 25px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(103, 65, 217, 0.3);
  transform: translateY(0px);

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
      from 0deg,
      transparent 70deg,
      rgb(103, 65, 217) 120deg,
      #ff6b9d 180deg,
      rgb(103, 65, 217) 240deg,
      transparent 290deg
    );
    animation: rotate 3s linear infinite !important;
    animation-play-state: running !important;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: #1a1a1a;
    border-radius: 25px;
    z-index: -1;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

function Header() {
  const [pendingSongRequestsCount, setPendingSongRequestsCount] =
    useState(null);
  const [showNav, setShowNav] = useState(false);
  const [hostName, setHostName] = useState("");
  const [active, setActive] = useState(window.location.pathname);
  const logoutRequest = useApi();
  const [isThirdPartyBrand, setIsThirdPartyBrand] = useState(
    getLocalStorage("business_type") === "brand"
  );

  useEffect(() => {
    // Check localStorage periodically for business_type updates
    const checkInterval = setInterval(() => {
      const flag = getLocalStorage("business_type");
      setIsThirdPartyBrand(flag === "brand");
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  const getNotificationData = () => {
    return getLocalStorage("notification_data")
      ? JSON.parse(getLocalStorage("notification_data"))
      : undefined;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      const data = getNotificationData();
      setPendingSongRequestsCount(data?.current?.pending);
    }, 500);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  const getCurrentMessage = () => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    if (currentHour < 12 && currentHour > 4) {
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 16) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (hostName == "") {
        setHostName(getLocalStorage("venue_name"));
        clearInterval(interval);
      }
    }, 500);
  }, []);

  const handleClickOutside = () => {
    setShowNav(false);
  };

  const handleRoute = (routeparam) => {
    setActive(routeparam);
    route(routeparam);
  };

  useEffect(() => {
    if (
      logoutRequest.data &&
      logoutRequest.data.data &&
      logoutRequest.data.data.logout
    ) {
      route("/");
      clearLocalStorage();
      clearCookies();
    }
    if (logoutRequest.errorBody?.response?.data?.response === "Failed") {
      clearLocalStorage();
      clearCookies();
      route("/");
    }
  }, [logoutRequest.data, logoutRequest.errorBody]);

  const userLogout = () => {
    logoutApi(logoutRequest.request, {
      host: getLocalStorage("host"),
    });
  };
  return (
    <Fragment>
      <ContentWrapper>
        <div className="leftText">
          {getCurrentMessage()}, {hostName}
        </div>
        {showNav && (
          <div className="nav-menu">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "20px 10px 10px 10px",
              }}
            >
              <img
                src={Logo}
                alt="Dhun Jam"
                style={{
                  width: "160px",
                  height: "auto",
                }}
              />
              <IconButton
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "13px",
                }}
                onClick={() => {
                  setShowNav(false);
                }}
              >
                <Close style={{ color: "white" }} />
              </IconButton>
            </div>

            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <div className="textMessage">
                {getCurrentMessage()}, {hostName}
              </div>
              <div
                className="userRoutes"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                {!isThirdPartyBrand && (
                  <>
                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/home/");
                      }}
                    >
                      <Home
                        className={
                          active !== "/home/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/home/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Home
                      </div>
                    </div>
                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/setting/");
                      }}
                    >
                      <Tune
                        className={
                          active !== "/setting/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/setting/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Settings
                      </div>
                    </div>

                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/analytics/");
                      }}
                    >
                      <Leaderboard
                        className={
                          active !== "/analytics/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/analytics/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Analytics
                      </div>
                    </div>
                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/played-songs/");
                      }}
                    >
                      <CheckBox
                        className={
                          active !== "/played-songs/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/played-songs/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Played
                      </div>
                    </div>
                  </>
                )}

                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/admin-offer/");
                  }}
                >
                  <LocalOffer
                    className={
                      active !== "/admin-offer/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/admin-offer/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Offers
                  </div>
                </div>

                {!isThirdPartyBrand && (
                  <div
                    className="navbarContainer"
                    onClick={() => {
                      handleRoute("/claim-offer/");
                    }}
                  >
                    <Verified
                      className={
                        active !== "/claim-offer/"
                          ? "navbarIcon"
                          : "activeNavbarIcon"
                      }
                    />
                    <div
                      className={
                        active !== "/claim-offer/"
                          ? "navbarRoute"
                          : "activeNavbarRoute"
                      }
                    >
                      Claims
                    </div>
                  </div>
                )}
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/event-offer/");
                  }}
                >
                  <Celebration
                    className={
                      active !== "/event-offer/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/event-offer/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Events
                  </div>
                </div>
                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/must-try/");
                  }}
                >
                  <Fastfood
                    className={
                      active !== "/must-try/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/must-try/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Must Try
                  </div>
                </div>

                {/* <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/services/");
                  }}
                >
                  <AdUnits
                    className={
                      active !== "/services/"
                        ? "navbarIcon"
                        : "activeNavbarIcon"
                    }
                  />
                  <div
                    className={
                      active !== "/services/"
                        ? "navbarRoute"
                        : "activeNavbarRoute"
                    }
                  >
                    Advertisement
                  </div>
                </div> */}

                <div
                  className="navbarContainer"
                  onClick={() => {
                    handleRoute("/promote/");
                  }}
                >
                  <Campaign
                    className={
                      active !== "/promote/" ? "navbarIcon" : "activeNavbarIcon"
                    }
                  />
                  <ExploreButton className={"navbarRoute"}>
                    Promote
                  </ExploreButton>
                </div>
                {!isThirdPartyBrand && (
                  <>
                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/check-in/");
                      }}
                    >
                      <SupervisedUserCircle
                        className={
                          active !== "/check-in/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/check-in/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Check-in
                      </div>
                    </div>
                    <div
                      className="navbarContainer"
                      onClick={() => {
                        handleRoute("/subscription/");
                      }}
                    >
                      <Wallet
                        className={
                          active !== "/subscription/"
                            ? "navbarIcon"
                            : "activeNavbarIcon"
                        }
                      />
                      <div
                        className={
                          active !== "/subscription/"
                            ? "navbarRoute"
                            : "activeNavbarRoute"
                        }
                      >
                        Subscription
                      </div>
                    </div>
                  </>
                )}
                <div
                  className="navbarContainer"
                  onClick={() => {
                    userLogout();
                  }}
                >
                  <Logout className="navbarIcon" />
                  <div className="navbarRoute">Logout</div>
                </div>
              </div>
            </div>
          </div>
        )}
        <IconButton
          className="menuIcon"
          style={{ padding: "4px 20px 0px 0px" }}
          onClick={() => {
            setShowNav(true);
          }}
        >
          <Menu />
        </IconButton>
        <div className="leftTextHere">
          {getCurrentMessage()}, {hostName}
        </div>
        {
          <div className="rightText">
            {pendingSongRequestsCount ? (
              <div className="pendingRequestCount">
                {pendingSongRequestsCount !== 0
                  ? `${pendingSongRequestsCount} ${
                      pendingSongRequestsCount === 1
                        ? " Pending Request"
                        : " Pending Requests"
                    }`
                  : ""}
              </div>
            ) : null}

            <div
              className="notificationsIcon mobile"
              style={{ padding: "8px" }}
            >
              <Badge badgeContent={pendingSongRequestsCount}>
                <NotificationsIcon style={{ color: "#fff" }} />
              </Badge>
            </div>
            <div
              className="notificationsIcon"
              style={{ padding: "4px 0px 0px 10px" }}
            >
              <NotificationsIcon style={{ color: "#fff" }} />
            </div>
          </div>
        }
      </ContentWrapper>
    </Fragment>
  );
}

export default Header;
